import { isEmpty } from 'ramda'
import {
  getNpscores,
  getReports,
  getSummary,
  getParticipation,
  getGroups,
  getGroupsTree,
} from '@/service/custom-surveys'

const getLabelByScore = score => {
  if (score === null) return undefined
  const scoreLabel = score.toString()
  return scoreLabel >= 10 ? score : score.toFixed(1)
}

// initial state
function initialState() {
  return {
    selectedGroupId: undefined,
    selectedQuestionId: undefined,
    groups: [],
    groupsTree: [],
    npscores: [],
    report: {},
    summary: {},
    participation: {
      invitedCount: undefined,
      confirmedCount: undefined,
      activeCount: undefined,
      createdAt: undefined,
      participationRate: undefined,
      history: {
        totalResponders: [],
        confirmedResponders: [],
        dates: [],
      },
    },
  }
}

const state = initialState()

// getters
const getters = {
  selectedGroupId: state => state.selectedGroupId,
  selectedQuestionId: state => state.selectedQuestionId,
  groups: state => state.groups,
  groupsTree: state => state.groupsTree,
  npscores: state => state.npscores,
  report: state => state.report,
  summary: state => state.summary,
  participation: state => state.participation,
}

// actions
const actions = {
  updateSelectedGroupId({ commit }, groupId) {
    commit('updateSelectedGroupId', groupId)
  },
  updateSelectedQuestionId({ commit }, guestionId) {
    commit('updateSelectedQuestionId', guestionId)
  },
  async loadGroupsTree({ commit }, { customSurveyId }) {
    const {
      data: { groups },
    } = await getGroupsTree(customSurveyId)

    commit('setGroupsTree', groups)
  },
  async loadGroups({ commit }, { customSurveyId }) {
    const {
      data: { groups },
    } = await getGroups(customSurveyId)

    commit('setGroups', groups)
  },
  async loadNpscores({ commit }, { customSurveyId, groupId }) {
    const {
      data: { npscores },
    } = await getNpscores(customSurveyId, groupId)

    commit('setNpscores', npscores)
  },
  async loadReports({ commit }, { customSurveyId, groupId }) {
    const {
      data: { report },
    } = await getReports(customSurveyId, groupId)

    if (!isEmpty(report)) {
      commit('setReport', report)
    }
  },
  async loadSummary({ commit }, { customSurveyId }) {
    const {
      data: { customSurvey },
    } = await getSummary(customSurveyId)

    commit('setSummary', customSurvey)
  },
  async loadParticipation({ commit }, { customSurveyId, groupId }) {
    const {
      data: { participation },
    } = await getParticipation(customSurveyId, groupId)
    commit('setParticipation', participation)
  },
}

// mutations
const mutations = {
  updateSelectedQuestionId(state, questionId) {
    state['selectedQuestionId'] = questionId
  },
  updateSelectedGroupId(state, groupId) {
    state['selectedGroupId'] = groupId
  },
  setGroupsTree(state, groupsTree) {
    state['groupsTree'] = groupsTree
  },
  setGroups(state, groups) {
    state['groups'] = groups
  },
  setNpscores(state, npscores) {
    for (let index = 0; index < npscores.length; ++index) {
      const npscore = npscores[index]

      // --- Mock dos meses restantes ---
      const his = []
      const lastNpscore = npscore.history[npscore.history.length - 1]
      let i = new Date(lastNpscore.date).getMonth() + 1

      while (his.length < 15) {
        if (i >= 12) {
          i = 1
        } else {
          i++
        }

        let monthScore = {
          promoters: 0,
          detractors: 0,
          passives: 0,
          not_answered: 0,
          score: 0,
          date: '2018-' + (i < 10 ? '0' + i : i) + '-01',
        }

        his.push(monthScore)
      }

      for (i = 0; i < npscore.history.length; i++) {
        his.push(npscore.history[i])
      }

      Object.assign(npscore, { history: his })
    }
    state['npscores'] = npscores
  },
  setReport(state, report) {
    report.categories = report.categories
      ? report.categories.map(c => ({
          ...c,
          scoreLabel: getLabelByScore(c.score),
          link: { name: 'custom-surveys.reports', params: { id: '' } },
        }))
      : []
    state['report'] = report
  },
  setSummary(state, summary) {
    state['summary'] = summary
  },
  setParticipation(state, participation) {
    Object.assign(state['participation'], participation)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
